import { useMemo } from 'react';
import { useLazyQuery } from '@apollo/client';
import { NOTIFICATION_QUERY } from '../../queries';

export function useNotificationQuery( notificationId, options ) {
    const [ fetchNotification, { data: rawData, loading, error, refetch, called } ] = useLazyQuery( NOTIFICATION_QUERY, {
        ...options,
        variables: { ...options?.variables, notificationID: notificationId },
    } );

    return useMemo ( () => {
        return {
            fetch: fetchNotification,
            error,
            loading,
            data: rawData,
            refetch,
            called
        };
    }, [ error, loading, rawData, refetch ] );
}
